export const locations = [
  {
    id: 1,
    name: 'Hattrick',
    address: '25155 FM2978',
    city: 'Tomball, TX 77375',
    distance: '1.2 miles away',
    status: 'active',
    cityValue: 'tomball',
    mapUrl: 'https://maps.app.goo.gl/zzuf9wwBGGHFEkVXA',
  },
  {
    id: 2,
    name: 'Ants Beer Cave',
    address: '440 E St Elmo Rd E-2',
    city: 'Austin, TX 78745',
    distance: '3.4 miles away',
    status: 'active',
    cityValue: 'austin',
    mapUrl: 'https://maps.app.goo.gl/FasJYbzpiVXUvp4t9',
  },
  {
    id: 3,
    name: 'Crossbar Denton',
    address: '2686 Old Alton Rd,',
    city: 'Denton, TX 76210',
    distance: '15.2 miles away',
    status: 'active',
    cityValue: 'denton',
    mapUrl: 'https://maps.app.goo.gl/i4hND5zoqsC3CA9m8',
  },
  {
    id: 4,
    name: 'ATP Pickleball Club',
    address: '719 S Interstate 35, Denton, TX 76205, United States',
    city: 'Denton, TX 76205',
    distance: '18.5 miles away',
    status: 'coming-soon',
    cityValue: 'denton',
    mapUrl: 'https://maps.app.goo.gl/AqVfTuFTmsH4ezQw6',
  },
  {
    id: 5,
    name: 'Crossbar Richardson',
    address: '1000 Hampshire Ln, Richardson, TX 75080, United States',
    city: 'Richardson, TX 75080',
    distance: '195 miles away',
    status: 'active',
    cityValue: 'richardson',
    mapUrl: 'https://maps.app.goo.gl/ghyaBahDhPjnph3h8',
  },
  {
    id: 6,
    name: 'Motion Indoor',
    address: '7003 S Cooper St',
    city: 'Arlington, TX 76001',
    distance: '196 miles away',
    status: 'active',
    cityValue: 'arlington',
    mapUrl: 'https://maps.app.goo.gl/pR4yAPeEt1F3AW926',
  },
];

export const cityOptions = [
  { value: 'austin', label: 'Austin, TX' },
  { value: 'richardson', label: 'Richardson, TX' },
  { value: 'tomball', label: 'Tomball, TX' },
  { value: 'denton', label: 'Denton, TX' },
  { value: 'arlington', label: 'Arlington, TX' },
];

export const mapPositions = {
  1: { top: '30%', left: '25%' },
  2: { top: '40%', left: '55%' },
  3: { top: '25%', left: '75%' },
  4: { top: '55%', left: '45%' },
  5: { top: '70%', left: '20%' },
  6: { top: '65%', left: '60%' },
  7: { top: '80%', left: '80%' },
  8: { top: '45%', left: '35%' },
};
